@if (captureDataForm()) {
  <div class="capture-lineitems-form" [formGroup]="captureDataForm()">
    <p-table
      stripedRows
      [columns]="lineItemProps()"
      [value]="lineItemControls"
      [formArrayName]="lineItemsFormGroupName()"
    >
      <ng-template #caption>
        <div class="capture-lineitems-table-header">
          <h3>{{ 'lineItems.title' | translate }}</h3>
          <p-button
            [ariaLabel]="'lineItems.addLineItem' | translate"
            icon="pi pi-plus"
            size="small"
            variant="outlined"
            (onClick)="addLineItemForm()"
          ></p-button>
        </div>
      </ng-template>
      <ng-template #header let-columns>
        <tr>
          <th id="actions" style="text-align: center">#</th>
          @for (col of columns; track col) {
            <th id="{{ col }}">
              <span class="th-label-wrapper">
                {{ col }}
                <i
                  class="pi pi-info-circle info-icon"
                  [pTooltip]="'tooltips.' + col | translate"
                  tooltipPosition="top"
                ></i>
              </span>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template #body let-row let-columns="columns" let-index="rowIndex">
        <tr [formGroup]="row">
          <td>
            <p-button
              [ariaLabel]="'lineItems.removeLineItem' | translate"
              icon="pi pi-times"
              size="small"
              variant="text"
              severity="danger"
              (onClick)="removeLineItemRowFromIndex(index)"
            ></p-button>
          </td>
          @for (col of columns; track col) {
            <td
              formGroupName="{{ col }}"
              class="{{ getFormFieldClassConfidenceByFormGroupName(row, col) }}"
            >
              <p-inputgroup>
                <input
                  pInputText
                  id="{{ col }}_{{ index }}"
                  formControlName="value"
                  autocomplete="off"
                />
                <p-inputgroup-addon>
                  {{ getConfidenceByFormGroupName(row, col) }}
                </p-inputgroup-addon>
              </p-inputgroup>
            </td>
          }
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="5">{{ 'lineItems.noItemsCaptured' | translate }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}
